function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React from 'react';
import PropTypes from 'prop-types';
import StackedBarPlotSection from './Stacked';
import GroupedBarPlotSection from './Grouped';
import SingleColumnBarPlotSection from './Column';
import 'scss/cndc_prices.scss';

var PlotSection =
/*#__PURE__*/
function (_React$Component) {
  _inherits(PlotSection, _React$Component);

  function PlotSection() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, PlotSection);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(PlotSection)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.render = function () {
      var _this$props = _this.props,
          plot = _this$props.plot,
          actions = _this$props.actions,
          countryID = _this$props.countryID,
          plotID = _this$props.plotID,
          windowWidth = _this$props.windowWidth,
          format = _this$props.format,
          height = _this$props.height;
      if (format === 'grouped') return React.createElement(GroupedBarPlotSection, {
        height: height,
        plot: plot,
        actions: actions,
        plotID: plotID,
        countryID: countryID,
        controls: plot.controls,
        windowWidth: windowWidth
      });
      if (format === 'stacked') return React.createElement(StackedBarPlotSection, {
        plot: plot,
        height: height,
        actions: actions,
        plotID: plotID,
        countryID: countryID,
        controls: plot.controls,
        windowWidth: windowWidth
      });

      if (format === 'column') {
        return React.createElement(SingleColumnBarPlotSection, {
          plot: plot,
          height: height,
          actions: actions,
          plotID: plotID,
          countryID: countryID,
          controls: plot.controls,
          windowWidth: windowWidth
        });
      }

      return React.createElement("div", null);
    };

    return _this;
  }

  return PlotSection;
}(React.Component);

export { PlotSection as default };
PlotSection.propTypes = {
  plotID: PropTypes.string,
  plot: PropTypes.object,
  format: PropTypes.string,
  height: PropTypes.string,
  loading: PropTypes.bool,
  countryID: PropTypes.string,
  actions: PropTypes.object,
  windowWidth: PropTypes.number,
  checkboxState: PropTypes.object,
  data: PropTypes.oneOfType([PropTypes.object, PropTypes.array])
};